import { Route, Routes, useLocation } from 'react-router-dom';
import CheckAuth from './checkAuth';
import RequireAuth from './authRouter';

import Login from '../pages/login';
import Home from '../pages/home';
import Devices from '../pages/devices';
import TagList from '../pages/tag';
import FCData from '../pages/fcdata';
import GCData from '../pages/gcdata';
import EVCData from '../pages/evcdata';
import ControllerData from '../pages/controlerdata';
import HourlyReportTable from '../pages/hourlyreport';
import DailyReportTable from '../pages/dailyreport';
import ReportPage from '../pages/filteredreport';
import AlarmsSettingsPage from '../pages/alarms';
import AlarmsReportPage from '../pages/alarmReportPage';
import AlarmDisplay from '../pages/alarmDisplay';
import SettingsPage from '../pages/settingsPageForReport';
import ServiceSettingPage from '../pages/serviceSettingPage';
import ServiceSummaryPage from '../pages/serviceSummaryPage';
import ServiceHistoryPage from '../pages/serviceHistoryPage';
import FlowPage from '../pages/FlowPage';
import CreateFunctionPage from '../pages/CreateFunctionPage';
import CalculationList from '../pages/calculation';
import SystemFlowList from '../pages/systemFlow';
import UserListPage from '../pages/user';
import ProfilePage from '../pages/profile';
import FlowComponent from '../components/FlowComponent';
import CustomReport from '../pages/CustomReport';
import CustomReportCreatePage from '../pages/CustomReportCreatePage';

function AppRouter() {
  const location = useLocation();
  const isViewMode = location.pathname.includes('/flow/view/');

  return (
    <>
      {isViewMode ? (
        <Routes>
          <Route path="flow/view/:id" element={<FlowComponent mode="view" />} />
        </Routes>
      ) : (
        <Routes>
          <Route element={<CheckAuth />}>
            <Route path={'login'} element={<Login />} />
          </Route>
          <Route element={<RequireAuth />}>
            <Route index element={<Home />} />
            <Route path={'settings/devices'} element={<Devices />} />
            <Route path={'settings/tag'} element={<TagList />} />
            <Route
              path={'settings/calculation'}
              element={<CalculationList />}
            />
            <Route path={'settings/user'} element={<UserListPage />} />
            <Route path={'profile'} element={<ProfilePage />} />
            <Route
              path={'settings/calculation/functions/:id'}
              element={<CreateFunctionPage />}
            />
            <Route path={'measurement/fc-data'} element={<FCData />} />
            <Route path={'measurement/gc-data'} element={<GCData />} />
            <Route path={'measurement/evc-data'} element={<EVCData />} />
            <Route
              path={'measurement/controller-data'}
              element={<ControllerData />}
            />
            <Route path={'report/hourly'} element={<HourlyReportTable />} />
            <Route path={'report/daily'} element={<DailyReportTable />} />
            <Route path={'report/detailed'} element={<ReportPage />} />
            <Route path={'report/Custom'} element={<CustomReport />} />
            <Route
              path="settings/custom-reports/:id"
              element={<CustomReportCreatePage />}
            />

            <Route path={'report/settings'} element={<SettingsPage />} />
            <Route path={'alarm/settings'} element={<AlarmsSettingsPage />} />
            <Route path={'alarm/history'} element={<AlarmsReportPage />} />
            <Route path={'alarm/display'} element={<AlarmDisplay />} />

            <Route path={'flow/screens'} element={<SystemFlowList />} />
            <Route path={'flow/create-new'} element={<FlowPage />} />
            <Route
              path="flow/edit/:id"
              element={<FlowComponent mode="edit" />}
            />
            <Route path={'service/settings'} element={<ServiceSettingPage />} />
            <Route path={'service/summary'} element={<ServiceSummaryPage />} />
            <Route path={'service/history'} element={<ServiceHistoryPage />} />
          </Route>
        </Routes>
      )}
    </>
  );
}

export default AppRouter;
